import { createSelector } from 'reselect';
import { getFormValues } from 'redux-form';
import { mapFilter, sortByKey, isObject } from 'utils/helpers';

/**
 * Direct selector to the channelsPage state domain
 */
const selectChannelsPageDomain = () => state => state.channels;

const selectChannelsFormValuesDomain = () => state =>
  ({ ...getFormValues('channelForm')(state) });

/**
 * Other specific selectors
 */

const selectAllChannels = () => createSelector(
  selectChannelsPageDomain(),
  substate => substate.allChannels
);

const selectChannelThemes = () => createSelector(
  selectChannelsPageDomain(),
  substate => sortByKey(substate.channelThemes)
);

const selectModes = () => createSelector(
  selectChannelsPageDomain(),
  substate => sortByKey(substate.modes)
);

const selectClientFilter = () => createSelector(
  selectChannelsPageDomain(),
  substate => substate.clientFilter
);

const selectStatusFilter = () => createSelector(
  selectChannelsPageDomain(),
  substate => substate.statusFilter
);

const selectIsFetching = () => createSelector(
  selectChannelsPageDomain(),
  substate => substate.isFetching
);

const selectClients = () => createSelector(
  selectChannelsPageDomain(),
  substate => substate.clients
);

const selectCurrentTab = () => createSelector(
  selectChannelsPageDomain(),
  substate => substate.currentTab
);

const selectChannelFormName = () => createSelector(
  selectChannelsFormValuesDomain(),
  substate => substate.name
);

const selectChannelFormPassword = () => createSelector(
  selectChannelsFormValuesDomain(),
  substate => substate.password
);

const selectChannelModeId = () => createSelector(
  selectChannelsFormValuesDomain(),
  substate => substate.mode_id
);

const selectChannelFormSlug = () => createSelector(
  selectChannelsFormValuesDomain(),
  substate => substate.slug
);

const selectChannelSlugIsValid = () =>
  createSelector(selectChannelsPageDomain(), (substate) =>
   substate.validSlug
  );

  const selectSlugIsValidating = () => createSelector(
  selectChannelsPageDomain(),
  substate =>substate.slugIsValidating
);

const selectChannelFormLogo = () => createSelector(
  selectChannelsFormValuesDomain(),
  substate => substate && substate.big_logo_image
);

const selectChannelFormBackground = () => createSelector(
  selectChannelsFormValuesDomain(),
  substate => substate && substate.app_background_color
);

const selectChannelFormGalleryBackground = () => createSelector(
  selectChannelsFormValuesDomain(),
  substate => substate && substate.gallery_color
);

const selectChannelFormThemeId = () => createSelector(
  selectChannelsFormValuesDomain(),
  substate => substate && substate.channel_theme_id
);

const selectChannelFormFirstLine = () => createSelector(
  selectChannelsFormValuesDomain(),
  substate => substate && substate.first_line_text
);

const selectChannelFormSecondLine = () => createSelector(
  selectChannelsFormValuesDomain(),
  substate => substate && substate.second_line_text
);

const selectChannelFormThemeInstance = () => createSelector(
  selectChannelsFormValuesDomain(),
  substate => substate && substate.channel_theme_instance
);

const selectChannelFormGifMode = () => createSelector(
  selectChannelsFormValuesDomain(),
  substate => substate && substate.gif_mode
);

const selectChannelFormWithFilter = () => createSelector(
  selectChannelsFormValuesDomain(),
  substate => substate && substate.with_photo_filter
);

const selectChannelFormWithFilterGraphic = () => createSelector(
  selectChannelsFormValuesDomain(),
  substate => substate && substate.with_photo_filter_graphic
);

const selectChannelThemeInstances = () => createSelector(
  selectChannelsPageDomain(),
  substate => substate.channelThemeInstances
);

const selectChannelImageCustomization = () => createSelector(
  selectChannelsFormValuesDomain(),
  substate => substate.channel_image_customization
);

const selectBrandFormData = () => createSelector(
  selectChannelsFormValuesDomain(),
  substate => {
    const urlFix = (url) => url && (isObject(url) || !url.includes('missing.png')) ? url : null;
    const keys = [
      'big_logo_image_url',
      'app_background_color',
      'overlay_image',
      'photo_filters',
      'gallery_banner',
      'header',
      'sub_header',
      'gallery_cta_text',
      'gallery_cta_link',
      'gallery_color',
      "app_background_color"
    ]
    var data = {};
    if (substate) {
      keys.map((key) => {
        if (
          ["big_logo_image_url", "overlay_image", "gallery_banner"].includes(
            key
          )
        ) {
          data[key] = urlFix(substate[key]);
        } else if (key === "photo_filters") {
          if (
            Array.isArray(substate[key]) &&
            !!substate[key][0] &&
            !!substate[key][0].file 
          ) {
            data[key] = substate["photo_filters"].filter(
              (filter) => !!filter.file && filter.file.name !== null
            );
          } 
        } else {
          data[key] = substate[key];
        }
      });
    }

    return data;
  }
);

const selectMessageFormData = () => createSelector(
  selectChannelsFormValuesDomain(),
  substate => {
    const keys = ['email_cta_button_color', 'email_cta_button_text_color']
    var data = {};
    if (substate) {
      keys.map(key => {
        data[key] = substate[key];
      })
    }

    return data;
  }
);

const selectUseMoveboothTheme = () => createSelector(
  selectChannelsFormValuesDomain(),
  substate => substate.useMoveboothTheme
);
/**
 * Default selector used by ChannelsPage
 */

const selectChannels = () => createSelector(
  selectChannelsPageDomain(),
  (substate) => substate
);

const selectPermissionRole = () => state => state.app.user.permission_role;

const selectChannelErrors = () => createSelector(
  selectChannelsPageDomain(),
  substate => substate.errors
);
export default selectChannels;
export {
  selectChannelsPageDomain,
  selectClientFilter,
  selectStatusFilter,
  selectIsFetching,
  selectClients,
  selectSlugIsValidating,
  selectChannelFormName,
  selectChannelFormPassword,
  selectChannelModeId,
  selectChannelFormSlug,
  selectCurrentTab,
  selectAllChannels,
  selectChannelFormLogo,
  selectChannelFormBackground,
  selectChannelFormGalleryBackground,
  selectChannelThemes,
  selectModes,
  selectChannelSlugIsValid,
  selectChannelThemeInstances,
  selectChannelFormThemeId,
  selectChannelFormThemeInstance,
  selectChannelFormFirstLine,
  selectChannelFormSecondLine,
  selectChannelFormGifMode,
  selectChannelFormWithFilterGraphic,
  selectChannelFormWithFilter,
  selectBrandFormData,
  selectChannelImageCustomization,
  selectMessageFormData,
  selectPermissionRole,
  selectUseMoveboothTheme,
  selectChannelErrors,
};



// WEBPACK FOOTER //
// ./src/containers/ChannelsPage/selectors.js